import type { NavGroupDef } from './navGroups';

/** Subconjunto scoped de NavTo (TENANT). Espejo del patrón de PlatformNavTo. */
export type ScopedNavTo =
    | '/tenant/groups'
    | '/tenant/users'
    | '/tenant/roles'
    | '/tenant/branding'
    | '/tenant/security'
    | '/tenant/audit';

/** Las categorías comunes del menú scoped del tenant. */
export type ScopedGroupId = 'estructura' | 'access' | 'system';

type ScopedNavGroup = NavGroupDef<ScopedGroupId, ScopedNavTo>;

// El orden de los items respeta el orden funcional actual del sidebar (no alfabético).
// Rutas, permisos y labelKeys son EXACTAMENTE los de AppShell hoy.
export const TENANT_NAV_GROUPS: ScopedNavGroup[] = [
    {
        // DEC-032: recursos de nivel del tenant. Hoy un único item "Grupos" (LEVEL_1) — el
        // tenant-context no tiene la lista de `levels[]` con displayNames, así que no se puede
        // dinamizar sin cambio de backend (exponer `levels[]` en /me/profile). Ver TD-WEBAPP-034.
        id: 'estructura',
        titleKey: 'common:nav.tenant.groupTitles.estructura',
        items: [
            {
                to: '/tenant/groups',
                permission: 'tenant.level.manage',
                labelKey: 'common:nav.tenant.groups',
            },
        ],
    },
    {
        id: 'access',
        titleKey: 'common:nav.tenant.groupTitles.access',
        items: [
            {
                to: '/tenant/users',
                permission: 'tenant.user.read',
                labelKey: 'common:nav.tenant.users',
            },
            {
                to: '/tenant/roles',
                permission: 'tenant.role.list',
                labelKey: 'common:nav.tenant.roles',
            },
        ],
    },
    {
        id: 'system',
        titleKey: 'common:nav.tenant.groupTitles.system',
        items: [
            {
                to: '/tenant/branding',
                permission: 'tenant.branding.manage',
                labelKey: 'common:nav.tenant.branding',
            },
            {
                to: '/tenant/security',
                permission: 'tenant.security.policy.view',
                labelKey: 'common:nav.tenant.security',
            },
            {
                to: '/tenant/audit',
                permission: 'tenant.audit.view',
                labelKey: 'common:nav.tenant.audit',
            },
        ],
    },
];
